import * as React from 'react';
import { connect } from 'react-redux';
import { ButtonCheckbox } from '../../../../common/components/button_checkbox';
import { IAppState, Dispatch } from '../../../../common/state';
import {
  changeBuildingDone,
  changeBuildingDoneInYear,
  changeBuildingDoneLater,
} from '../../../state/advanced/done_year';
import { InlineParam, Row } from '../markup';

export interface IDoneYearProps {
  buildingDone: boolean;
  onBuildingDoneChanged(value: boolean): void;

  allowedYears: number[];
  onBuildingDoneInYear(value: boolean, year: number): void;

  later: boolean;
  onBuildingDoneLaterChanged(year: number | undefined): void;
}

const CURRENT_YEAR = new Date().getFullYear();

export const doneYear: React.StatelessComponent<IDoneYearProps> = props => (
  <Row title="Год сдачи ЖК">
    <InlineParam>
      <ButtonCheckbox value={props.buildingDone} onValueChange={value => props.onBuildingDoneChanged(value)}>
        Сдан
      </ButtonCheckbox>
    </InlineParam>

    {[CURRENT_YEAR, CURRENT_YEAR + 1, CURRENT_YEAR + 2, CURRENT_YEAR + 3].map((year, i) => (
      <InlineParam key={i.toString()}>
        <ButtonCheckbox
          value={props.allowedYears.indexOf(year) !== -1}
          onValueChange={value => props.onBuildingDoneInYear(value, year)}
        >
          {year}
        </ButtonCheckbox>
      </InlineParam>
    ))}

    <InlineParam>
      <ButtonCheckbox
        value={props.later}
        onValueChange={value => props.onBuildingDoneLaterChanged(value ? CURRENT_YEAR + 4 : undefined)}
      >
        Позднее
      </ButtonCheckbox>
    </InlineParam>
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    buildingDone: (state.filters.jsonQuery.hand_over && state.filters.jsonQuery.hand_over.value) || false,
    allowedYears: (state.filters.jsonQuery.year && state.filters.jsonQuery.year.value) || [],
    later: !!(state.filters.jsonQuery.yeargte && state.filters.jsonQuery.yeargte.value),
  }),
  (dispatch: Dispatch) => ({
    onBuildingDoneChanged: (value: boolean) => {
      dispatch(changeBuildingDone(value));
    },
    onBuildingDoneInYear: (value: boolean, year: number) => {
      dispatch(changeBuildingDoneInYear(value, year));
    },
    onBuildingDoneLaterChanged: (year: number | undefined) => {
      dispatch(changeBuildingDoneLater(year));
    },
  }),
)(doneYear);
